const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/triemli/setup.ts';
import { PatAppConfiguration } from 'App/defs/setupDefs';
import textMap from './translations';
import ECheckinForm from 'App/config/triemli/eCheckin/ECheckinForm';
import { useECheckinInitialValues } from './eCheckin/initialValues';
import Footer from 'App/config/triemli/Footer';

export const configuration: PatAppConfiguration = {
    languages: ['de', 'fr', 'en', 'it'],
    footer: Footer,
    eCheckin: {
        initialValuesHook: useECheckinInitialValues,
        form: ECheckinForm,
    },
    navbarTitle: textMap.navbarTitle,
    welcomeTitle: undefined,
    welcomeText: textMap.welcomeText,
    synedraCardTitle: undefined,
    urls: {
        website: 'https://www.stadt-zuerich.ch',
        loginHelp: 'https://www.stadt-zuerich.ch/stadtspital/de/ueber-uns/standorte.html',
    },
    customMetaKatMultipleKeys: undefined,
    customMatomoClientId: undefined,
    bookAppointmentInfo: undefined,
    bookAppointmentSlotOffset: {
        amount: 24,
        unit: 'hours',
    },
    surgeryCardHint: undefined,
    SurgeryCardContactAlert: undefined,
    surgeryAppointmentDeadline: undefined,
    videoCallDisclaimerText: undefined,
    aiaiBotApiKey: undefined,
};

export const { customMetaKatMultipleKeys } = configuration;
